import React from 'react';

import { Input } from 'antd';
import { useIntl } from 'react-intl';

import type {
  FilterValues,
  SetValueProps,
} from '@src/components/FilterDropDown/FilterDropDown.interfaces';
import {
  buildJobsListFilterSetValueProps,
  JOBS_LIST_FILTER_FIELDS,
} from '@src/packages/jobs/jobsListFilterConfig';

interface JobFiltersProps {
  handleFilters: (props: SetValueProps) => void;
  filters: FilterValues;
}

const JobFilters: React.FC<JobFiltersProps> = ({ handleFilters, filters }) => {
  const intl = useIntl();

  return (
    <Input
      placeholder={intl.formatMessage({ id: 'position.job.filter.placeholder' })}
      className="gx-m-0"
      onChange={e =>
        handleFilters(
          buildJobsListFilterSetValueProps(JOBS_LIST_FILTER_FIELDS.NAME, e.target.value, intl),
        )
      }
      value={String(filters[JOBS_LIST_FILTER_FIELDS.NAME]?.value ?? '')}
      id={JOBS_LIST_FILTER_FIELDS.NAME}
    />
  );
};

export default React.memo(JobFilters);
